import Button from '@mui/material/Button'
import { useFormContext } from 'react-hook-form'
import { Box } from '../../../../components/Box.tsx'
import { FormLabel } from '../../../../components/generic.tsx'
import { I18n } from '../../../../components/I18n.tsx'
import { Stack } from '../../../../components/Stack.tsx'
import { ids } from '../../../../ids.ts'
import { TimezonePicker } from '../../../preferences/TimezonePicker.tsx'
import { getSystemTimezone } from '../../../preferences/timezones.ts'
import { type BaseReportForm, useBaseFormValues } from '../schema.ts'

export const TimezoneField = () => {
	const { setValue } = useFormContext<BaseReportForm>()
	const [timezone] = useBaseFormValues(['preferences.timezone'])

	return (
		<Box>
			<FormLabel required>{<I18n i18nKey={($) => $.reports.form.timezone} />}</FormLabel>
			<Stack data-ta={ids.reports.form.timeRange.timezone} direction='row' center>
				<TimezonePicker value={timezone} onChange={(value) => setValue('preferences.timezone', value)} />
				<Button
					data-ta={ids.reports.form.timeRange.localTimeBtn}
					sx={{ flexShrink: 0 }}
					variant='text'
					onClick={() => setValue('preferences.timezone', getSystemTimezone())}
					size='small'
				>
					<I18n i18nKey={($) => $.reports.form.localTime} />
				</Button>
			</Stack>
		</Box>
	)
}
